import Service from "../../services";

// initial state
const state = {
  articles: [],
};

// getters
const getters = {};

// actions
const actions = {
  async populateIndustries({ commit }) {
    const industries = await Service.industry.getIndustries();
    commit("setIndustries", industries);
    return industries;
  },
  get({ commit }, id) {
    console.log(id);
    return Service.webdata
      .getArticleDetail(id)
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
};

// mutations
const mutations = {
  setIndustries(state, industries) {
    state.industries = industries;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
